export default {
      id: "close-usage",
      viewBox: "0 0 25 25",
      url: "/dist/svg/" + "sprite.svg#close-usage",
      toString: function () {
        return this.url;
      }
    }